import {AppDto} from 'src/dtos/app.dto';
import axiosService from './axios-service';
import {FwVersionContentAndMetadata} from '../dtos/version.dto';
import {ApplicationsDefaultBehavior, Direction} from '../utils/enums';
import {RecommendedAppData} from '../dtos/recommended-app.dto';

class ManagedAppsService {
    public addManagedApps = async (customerId: number, serviceId: number, externalId: string, appsList: string[]): Promise<FwVersionContentAndMetadata> => {
        const res = await axiosService.post(`/api/firewall/customer/${customerId}/service/${serviceId}/applications`,
            { externalId, managedAppsIdsToBeAdded: appsList });
        return res?.data;
    };

    public removeManageApp = async (customerId: number, serviceId: number, externalId: string, app: string): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.delete(`/api/firewall/customer/${customerId}/service/${serviceId}/applications`,
            { externalId, managedAppIdToRemove: app });
        return result?.data;
    };

    public searchApps = async (
                                                      searchStr: string): Promise<AppDto[]> => {
        const res = await axiosService.get(`/api/applications/search-apps/${searchStr}`);
        return res?.data as AppDto[];
    };

    public changeAppsDefaultBehavior = async (customerId: number, serviceId: number, externalId: string, applicationsDefaultBehavior: ApplicationsDefaultBehavior,
        direction: string): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.post(`/api/firewall/customer/${customerId}/service/${serviceId}/apps/default-behavior-change`,
            { externalId, applicationsDefaultBehavior, direction });
        return result?.data;
    };

    public updateAppStatus = async (customerId: number, serviceId: number, externalId: string, managedAppId: string,
        direction: Direction, isAllowed: boolean): Promise<FwVersionContentAndMetadata> => {
        const result = await axiosService.post(`/api/firewall/customer/${customerId}/service/${serviceId}/applications/allow-block-managed-app`,
            {
                externalId,
                managedAppId,
                direction: direction.toLowerCase(),
                allowed: isAllowed
            });
        return result?.data;
    };

    public getApplicationsIfExist = async (applicationsIds: string[]): Promise<AppDto[]> => {
        const result = await axiosService.post(`/api/applications/application/get-if-exist`, applicationsIds);
        return result?.data as AppDto[];
    };

    public getAppRecommendation = async (customerId: number, serviceId: number): Promise<RecommendedAppData> => {
        const result = await axiosService.get(`/api/firewall/customer/${customerId}/service/${serviceId}/apps/recommendations`);
        return result?.data;
    };

    public async addRecommendedApps(customerId: number, serviceId: number, recommendedAppsOutbound: string[], recommendedAppsInbound: string[]):
        Promise<FwVersionContentAndMetadata> {
        const result = await axiosService.put(`/api/firewall/customer/${customerId}/service/${serviceId}/applications/add-recommended-apps`, {
            recommendedAppsOutbound,
            recommendedAppsInbound
        });
        return result?.data;
    }

    public getAiApps = async (): Promise<AppDto[]> => {
        const res = await axiosService.get('/api/applications/get-ai-apps');
        return res?.data as AppDto[];
    };
}

const managedAppsService = new ManagedAppsService();
export default managedAppsService;